/**
 * Created by eddy on 08.10.2016.
 */
WW.social = {
    facebook: function(purl) {
        let url = 'https://facebook.com/sharer/sharer.php?m2w';
        url += '&p[url]=' + encodeURIComponent(purl);
        WW.social.popup(url);
    },
    twitter: function(purl) {
        let url  = 'http://twitter.com/share?';
        url += 'url='      + encodeURIComponent(purl);
        WW.social.popup(url);
    },
    google: function(purl) {
        let url = 'https://plus.google.com/share?';
        url += 'url='      + encodeURIComponent(purl);
        WW.social.popup(url);
    },
    linkedin: function(purl) {
        let url = 'https://www.linkedin.com/cws/share?';
        url += 'url='      + encodeURIComponent(purl);
        WW.social.popup(url);
    },
    popup: function(url) {
        var width  = 575,
            height = 520,
            left   = (jQuery(window).width()  - width)  / 2,
            top    = (jQuery(window).height() - height) / 2,
            opts   = 'status=1,toolbar=0' +
                ',width='  + width  +
                ',height=' + height +
                ',top='    + top    +
                ',left='   + left;
        window.open(url,'share',opts);
    }
};